<template>
  <div>
    <div class="header">
      <span>麻醉统计</span>
      <el-form :inline="true" class="header-right">
        <el-form-item>
          <el-select v-model="chid" placeholder="请选择医院" :disabled="hospitals.length <= 1" size="mini">
            <el-option
              v-for="item in hospitals"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            style="width: 280px"
            size="mini"
            v-model="dateScope"
            type="daterange"
            value-format="timestamp"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            range-separator="至"
            :picker-options="pickerOptions"
            clearable>
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" border v-loading.body="loading" stripe style="width: 100%;">
      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column v-for="item in columns"
        :key="item"
        :prop="item"
        :label="item"
        :formatter="formatterCountValue">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import _ from 'lodash';
  import moment from 'moment'
  import OrgService from '@/request/user/org'
  import OperationCountService from '@/request/count/operation'
  // import ListUtils from '@/utils/list'
  export default {
    name: "CountAnaesthesia",
    data() {
      return {
        tableData: [],
        columns: [],
        hospitals: [],
        chid: null,
        loading: false,
        dateScope: [moment().startOf('month').valueOf(), moment().subtract(1, 'days').endOf('day').valueOf()],
        options: {
          start: moment().startOf('month').valueOf(),
          end: moment().subtract(1, 'days').endOf('day').valueOf(),
          hid: 0
        },
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > moment().subtract(1, 'days').valueOf();
          },
          shortcuts: [{
            text: '本月',
            onClick (picker) {
              const end = moment().subtract(1, 'days').endOf('day').valueOf()
              const start = moment().startOf('month').valueOf()
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '上月',
            onClick (picker) {
              const end = moment().subtract(1, 'months').endOf('month').valueOf()
              const start = moment().subtract(1, 'months').startOf('month').valueOf()
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = moment().subtract(1, 'days').endOf('day').valueOf()
              const start = end - 3600 * 1000 * 24 * 30
              picker.$emit('pick', [start, end])
            }
          }]
        },
      }
    },
    watch: {
      chid (val, oval) {
        if (val === oval) {
          return;
        }
        this.listCount();
      },
      dateScope (val, oval) {
        if (!_.isEmpty(val) && !_.isEmpty(oval) && val[0] === oval[0] && val[1] === oval[1]) {
          return;
        }
        if (this.loading) {
          return;
        }
        if (!_.isEmpty(val)) {
          this.options.start = moment(val[0]).startOf('day').valueOf();
          this.options.end = moment(val[1]).endOf('day').valueOf();
        } else {
          this.options.start = moment().startOf('month').valueOf();
          this.options.end = moment().subtract(1, 'days').endOf('day').valueOf();
        }
        this.listCount();
      }
    },
    created() {
      this.listHospital();
    },
    methods: {
      formatterCountValue(row, column, cellValue) {
        if (!cellValue) {
          return 0;
        }
        return cellValue;
      },
      listCount() {
        if (!this.chid || this.loading) {
          if (!this.chid) {
            this.tableData = [];
          }
          return;
        }
        this.options.hids = this.chid;
        this.tableData = [];
        this.columns = [];
        this.loading = true;
        let prs = [OperationCountService.countUserAnaesthesia(this.options), OperationCountService.countOrgAnaesthesia(this.options)];
        Promise.all(prs).then(ress => {
          if (ress[0] && ress[0].result) {
            let userCounts = {};
            _.forEach(ress[0].result, count => {
              let doc = count['doc'];
              let anesthesiaType = count['anesthesiaType'];
              if (_.indexOf(this.columns, anesthesiaType) < 0) {
                this.columns.push(anesthesiaType);
              }
              if (!userCounts[doc]) {
                userCounts[doc] = {
                  id: doc,
                  name: count['name']
                };
              }
              userCounts[doc][anesthesiaType] = count.count;
            })
            _.forEach(userCounts, count => {
              this.tableData.push(count);
            })
          }
          if (ress[1] && ress[1].result) {
            let hospitalCounts = {
              id: 0,
              name: '医院总计'
            };
            _.forEach(ress[1].result, count => {
              let anesthesiaType = count['anesthesiaType'];
              if (_.indexOf(this.columns, anesthesiaType) < 0) {
                this.columns.push(anesthesiaType);
              }
              hospitalCounts[anesthesiaType] = count['count'];
            });
            this.tableData.push(hospitalCounts);
          }
        }).finally(() => {
          this.loading = false;
        });
      },
      listHospital () {
        OrgService.listOrg({
          parents: 1,
          descendant: 1,
          typeSns: 'lx0001001'
        }).then(res => {
          this.hospitals = _.cloneDeep(res.result || [])
          if (_.isEmpty(this.hospitals)) {
            return
          }
          if (!this.chid) {
            this.chid = this.hospitals[0].id
            return
          }
          this.listOids()
          if (_.isEmpty(this.currentHospital)) {
            let index = _.findIndex(this.hospitals, {'id': this.chid})
            if (index >= 0) {
              this.currentHospital = _.cloneDeep(this.hospitals[index])
            }
          }
        })
      }
    }
  }
</script>

<style scoped>
  .eber-count-table /deep/ .el-table__expanded-cell {
    padding: 0 0 0 48px;
    background-color: #f2f6fc;
  }
  .header {
    height: 50px;
    line-height: 48px;
    color: #000;
    border-bottom: 1px solid #ebeef5;
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 20px;
    position: relative;
  }
  .header-right{
    z-index: 999;
    float: right;
    position: absolute;
    right: 0;
    top: 4px;
  }
</style>
